module.exports = __webpack_public_path__ + "img/student.5beb2418.png";